import { N as Navigation, S as Swiper } from './navigation-BQV7P67J.js';

class SkewedSlider extends HTMLElement {
  connectedCallback() {
    const nextEl = `.swiper-next-${this.dataset.sectionId}`;
    const prevEl = `.swiper-prev-${this.dataset.sectionId}`;

    const defaultOptions = {
      modules: [Navigation],

      navigation: {
        nextEl,
        prevEl,
      },
    };
    //  HTML
    const options = JSON.parse(
      this.querySelector('[type="application/json"]')?.textContent || '{}'
    );

    this.initSwiper({ ...defaultOptions, ...options });
  }

  initSwiper(options) {
    const swiper = this.querySelector('.swiper--skewed');
    new Swiper(swiper, options);
  }
}

customElements.define('skewed-slider', SkewedSlider);
